<template>
	<div class="page_header">
		<login ref="login" v-if="loginVisible"></login>
		<div class="header_top">
			<div class="top_box page_wrapper">
				<span @click="joinFavorite()" style="cursor: pointer">加入收藏</span>
				<div class="right_box">
					<div class="search">
						<el-autocomplete
							class="inline-input"
							size="mini"
							v-model="searchText"
							value-key="goodsName"
							:fetch-suggestions="querySearch"
							placeholder="请输入设备名称"
							:trigger-on-focus="false"
							@select="handleSelect"
							suffix-icon="el-icon-search"
						></el-autocomplete>
						<!-- <el-input placeholder="请输入内容" size="mini" suffix-icon="el-icon-search"> </el-input> -->
					</div>
					<div class="person">
						<el-popover placement="bottom" width="328" ref="popoverlogin" popper-class="personPop" @show="popshowHandle" trigger="click">
							<el-button slot="reference" class="pgrup" size="small" type="text">
								<img class="avatar" src="@/assets/img/avatar.png" alt="" />
								<span class="ptext">{{ userInfo.name }} <i class="el-icon-arrow-down el-icon--right"></i></span>
							</el-button>
							<div class="popmain">
								<div class="ptop">
									<dl>
										<dt>
											<img class="avatar" src="@/assets/img/avatar.png" alt="" />
										</dt>
										<dd>
											<div class="info">
												<h3>
													{{ userInfo.username }} <span class="utype">{{ userInfo.userType == 1 ? '内部用户' : '外部用户' }}</span>
												</h3>
												<p>{{ userInfo.phone }}</p>
											</div>
											<span class="loginout" @click="logoutHandle()">退出</span>
										</dd>
									</dl>
								</div>
								<div class="pbtm">
									<div class="btnitem" @click="$router.push({ name: 'basicinfo' })">
										<img src="@/assets/img/u1.png" alt="" />
										<span>基本资料</span>
									</div>
									<div class="btnitem" @click="$router.push({ name: 'myorder' })">
										<img src="@/assets/img/u2.png" alt="" />
										<span>我的订单</span>
									</div>
									<div class="btnitem" @click="$router.push({ name: 'contribute' })">
										<img src="@/assets/img/u3.png" alt="" />
										<span>我的投稿</span>
									</div>
									<div class="btnitem" @click="$router.push({ name: 'updatepwd' })">
										<img src="@/assets/img/u4.png" alt="" />
										<span>密码修改</span>
									</div>
								</div>
							</div>
						</el-popover>
					</div>
				</div>
			</div>
		</div>
		<div class="header_main">
			<div class="main_box page_wrapper">
				<div class="logo"><img src="../../../public/page_logo.png" alt="" /></div>
				<div class="right_nav">
					<ul class="nav_list">
						<li :class="activeNav === nav.url ? 'active' : ''" class="m_nav" @click="$router.push({ name: nav.url })" v-for="nav of navList" :key="nav.id">
							<a>{{ nav.name }}</a>
							<ul class="child_nav" v-if="nav.children">
								<li v-for="child of nav.children" :key="child.id" @click.stop="$router.push({ name: child.url })">{{ child.name }}</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Login from '@/views/common/login'
import { clearLoginInfo } from '@/utils'
import storageUtils from '@/utils/storageUtils'
export default {
	components: {
		Login,
	},
	data() {
		return {
			activeNav: '',
			searchText: '',
			restaurants: [],
			whiteNav: ['home', 'contactUs', 'register', 'order', 'userguide'],
			navList: [
				{
					id: 1,
					name: '首页',
					url: 'home',
				},
				{
					id: 2,
					name: '公司概况',
					url: 'about',
				},
				{
					id: 3,
					name: '通知公告',
					url: 'news',
					// children: [
					// 	{
					// 		id: 301,
					// 		name: '中心新闻',
					// 		url: 'centerNews',
					// 	},
					// 	{
					// 		id: 302,
					// 		name: '通知公告',
					// 		url: 'broadcast',
					// 	},
					// ],
				},
				{
					id: 4,
					name: '资质荣誉',
					url: 'honor',
					children: [
						{
							id: 401,
							name: '技术资质',
							url: 'credential',
						},
						{
							id: 402,
							name: '公司荣誉',
							url: 'cpyhonor',
						},
					],
				},
				{
					id: 5,
					name: '仪器设备',
					url: 'device',
					children: [
						{
							id: 501,
							name: '公司设备',
							url: 'centralequpt',
						},
						{
							id: 502,
							name: '共享设备',
							url: 'shareequpt',
						},
						{
							id: 503,
							name: '院内设备',
							url: 'hosequpt',
						},
						{
							id: 504,
							name: '外部资源',
							url: 'outresources',
						},
					],
				},
				{
					id: 6,
					name: '技术服务',
					url: 'service',
					children: [
						{
							id: 601,
							name: '技术需求',
							url: 'demand',
						},
						{
							id: 602,
							name: '协创资源',
							url: 'cocreation',
						},
						{
							id: 603,
							name: '标准服务',
							url: 'standard',
						},
					],
				},
				{
					id: 7,
					name: '联系我们',
					url: 'contactUs',
				},
			],
		}
	},
	watch: {
		$route: 'init',
	},
	computed: {
		loginVisible: {
			get() {
				return this.$store.state.loginVisible
			},
			set(val) {
				this.$store.commit('updateLoginVisible', val)
			},
		},
		userInfo: {
			get() {
				return this.$store.state.userInfo
			},
			set(val) {
				this.$store.commit('updateUserInfo', val)
			},
		},
	},
	created() {
		console.log(this.$route)
		this.init()
		this.loadeqData()
	},
	methods: {
		init() {
			if (storageUtils.getUser()) {
				this.userInfo = storageUtils.getUser()
			}
			if (this.whiteNav.includes(this.$route.name)) {
				this.activeNav = this.$route.name || ''
			} else {
				this.navList.forEach(item => {
					this.$route.matched.forEach(m => {
						if (item.url === m.name) {
							this.activeNav = m.name
						} else {
							const matched = this.$route.matched || []
							if (matched && matched.length > 0) {
								const { name } = matched[2]
								this.activeNav = name
							}
						}
					})
				})
			}
		},
		popshowHandle() {
			let token = this.$cookie.get('X-Web-Token')
			console.log(token)
			if (!token) {
				this.$refs.popoverlogin.doClose()
				this.loginVisible = true
			} else {
				this.$refs.popoverlogin.doShow()
			}
		},
		// 退出登录
		logoutHandle() {

           this.$http.post(this.$api.userApi.userLogout).then(({ data }) => {
			clearLoginInfo()
			this.userInfo = {}
			this.$refs.popoverlogin.doClose()
			this.loginVisible = false
			this.$message({
				message: '已退出！',
				type: 'success',
				duration: 1000,
			 })
		   this.$router.push("/home")
		})


			
		},
		// 加入收藏
		joinFavorite() {
			var url = window.location
			var title = document.title
			var ua = navigator.userAgent.toLowerCase()
			if (ua.indexOf('360se') > -1) {
				alert('由于360浏览器功能限制，请按 Ctrl+D 手动收藏！')
			} else if (ua.indexOf('msie 8') > -1) {
				window.external.AddToFavoritesBar(url, title) //IE8
			} else if (document.all) {
				try {
					window.external.addFavorite(url, title)
				} catch (e) {
					alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
				}
			} else if (window.sidebar) {
				window.sidebar.addPanel(title, url, '')
			} else {
				alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
			}
		},
		// 设备列表
		loadeqData() {
			let params = {
				current: '1',
				size: '1000',
				data: {
					st: 1,
					gxtionType: '',
					cationType: '',
				},
			}
			this.$http.post(this.$api.goodsApi.goodsList, params).then(({ data }) => {
				this.restaurants = data.data.list
			})
		},
		// 搜索
		querySearch(queryString, cb) {
			var restaurants = this.restaurants
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter(queryString) {
			return restaurant => {
				return restaurant.goodsName.toLowerCase().indexOf(queryString.toLowerCase()) != -1
			}
		},
		// 搜索选择
		handleSelect(item) {
			console.log(item,'cccccccccccc')
			this.$store.commit('updateLayouSearMsg', item.goodsName)
			this.$router.push({ name: 'allequpt', query: { goodsName: item.goodsName, routeName: 'wtsj' } })
			this.searchText = ''
		},
	},
}
</script>

<style lang="scss" scoped>
.page_header {
	width: 100%;
	background: rgb(30, 138, 114);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	.header_top {
		background: #e6e6e6;
		.top_box {
			display: flex;
			height: 40px;
			align-items: center;
			justify-content: space-between;
			.right_box {
				display: flex;
				align-items: center;
				.search {
					margin-right: 30px;
				}
				.person {
					font-size: 14px;
					.pgrup ::v-deep {
						padding: 0;
						color: #333;
						.avatar {
							height: 27px;
							margin-right: 7px;
							margin-top: -5px;
						}
						.ptext {
							font-size: 14px;
							vertical-align: middle;
						}
					}
				}
			}
		}
	}
	.header_main {
		background: #fff;
		.main_box {
			display: flex;
			align-items: center;
			height: 112px;
			.logo {
				img {
					height: 65px;
				}
			}
			.right_nav {
				flex: 1;
				.nav_list {
					display: flex;
					align-items: center;
					justify-content: right;
					li.m_nav {
						position: relative;
						a {
							font-size: 18px;
							display: block;
							padding: 0 17px;
							height: 112px;
							line-height: 112px;
							font-weight: bold;
							user-select: none;
						}
						&:hover a {
							background: #2962b0;
							color: #fff;
							opacity: 0.9;
						}
						&:hover .child_nav {
							display: block;
						}
						.child_nav {
							display: none;
							position: absolute;
							top: 112px;
							left: 0;
							width: 100%;
							background: #2962b0;
							z-index: 99;
							li {
								height: 40px;
								line-height: 40px;
								text-align: center;
								border-top: 1px solid #ccc;
								user-select: none;
								color: #fff;
								&:hover {
									opacity: 0.9;
								}
							}
						}
					}
					li.active a {
						background: #2962b0;
						color: #fff;
					}
				}
			}
		}
	}
}
</style>
